// Polyfills
import 'babel-polyfill';
import 'intersection-observer';
import 'whatwg-fetch';

// Named Polyfills
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';

// Manager + In View
import InView from 'utils/in-view';
import Manager from 'views/manager';

// App Class
class App {

  /**
   * Constructor:
   * App constructor.
   *
   * @constructor
   */
  constructor() {
    // Resolve promises
    Promise.all([App.domReady()])
           .then(App.appReady());
  }

  /**
   * DOMReady:
   * Wait DOM to be loaded before resolving Promise and run application.
   *
   * @return {Promise} DOM Loaded Promise
   */
  static domReady() {
    // Wait DOMContentLoad to resolve Promise
    return new Promise((resolve) => {
      // Fire when DOM is loaded
      document.addEventListener('DOMContentLoaded', resolve);
    });
  }

  /**
   * AppReady:
   * Run application and manager when DOM is loaded.
   */
  static appReady() {
    // Fix SVG on IE
    svg4everybody();

    // Fix Object Fit Images
    objectFitImages();

    // Initialize In View
    window.InView = new InView();
     
    // Initialize manager
    window.Manager = new Manager();
  }
}

// Run application
new App();
